import { render, staticRenderFns } from "./ReadHome.vue?vue&type=template&id=5c60c476&scoped=true"
import script from "./ReadHome.vue?vue&type=script&lang=js"
export * from "./ReadHome.vue?vue&type=script&lang=js"
import style0 from "./ReadHome.vue?vue&type=style&index=0&id=5c60c476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c60c476",
  null
  
)

export default component.exports